import React from 'react';
import {TrackEvent} from '../../services/gtmEvents';

const SeoInterlinks = ({title, items}) => {
  return <div className="seo-interlinks">
    <h3>{title}</h3>
    <div className="interlinks-container">
      {items.map((item, j) => (
        <h4 key={j}><a href={item.url} onClick={() => TrackEvent('Navigation', 'Footer-Repuestos', item.title)}>{item.title}</a></h4>
      ))}
    </div>
  </div>;
};

export default SeoInterlinks;
